<!-- track my status popup -->
<div class="row m-0 p-0">
  <div class="order-tracking-status-popup-heading">{{'common.order_track_my_status_popup'|cxTranslate}}</div>
  <div class="order-tracking-status-popup-content">
    <table class="table">
      <thead>
        <tr>
          <th>{{'common.order_track_my_status_po'|cxTranslate}}</th>
          <th>{{'common.order_track_my_status_pos'|cxTranslate}}</th>
          <th>{{'common.order_track_my_status_part'|cxTranslate}}</th>
          <th>{{'common.order_track_my_status_qty'|cxTranslate}}</th>
          <th>{{'common.order_track_my_status_date-shipped'|cxTranslate}}</th>
          <th>{{'common.order_track_my_status_tracking'|cxTranslate}}</th>
          <th>{{'common.order_track_my_status_carrier'|cxTranslate}}</th>
        </tr>
      </thead>
      <tbody>
        @for (entry of data.orderDetails.entries; track entry) {
          <tr>
            <td data-name="">
            {{data.orderDetails?.purchaseOrderNumber}}</td>
            <td data-name="">{{entry.entryNumber}}</td>
            <td data-name=""> {{entry.product.code}}</td>
            <td data-name="">{{entry.quantity}}</td>
            <td data-name="">{{entry.requestedDeliveryDate}}</td>
            <td data-name="">{{entry.scheduleLines[0]?.trackingNumber}}</td>
            <td data-name="">{{entry.scheduleLines[0]?.carrier}}</td>
          </tr>
        }
      </tbody>
    </table>
    <div class="btn-block">
      <button class="btn btn-primary blue-btn"
        (click)="closeDialog()">{{'common.order_back_to_status'|cxTranslate}}<img
      src="/icons/link-white.svg" alt="image"></button>
    </div>
  </div>
</div>